import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class MaxExpression extends ExpressionRule {
    readonly __type: string = "Max";
    value1: ExpressionValue;

    constructor() {
        super();

        this.expressionValueType = new NumberDataDefinition();

        let dd = new NumberDataDefinition();
        dd.list = true;

        this.value1 = ExpressionValue.createExpressionValue(this, "maxValue", dd);
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return Math.max(...this.value1.evaluate(data, testContext));
    }
}
